import { AnyAction } from "redux";
import { 
  GET_ALL_CAMPAIGNS_EXPERIMENTAL
} from "../actions/CampaignExperimentalActions";
import { CampaignExperimentalListResponseDto } from "../models/campaignExperimental/CampaignExperimentalDto";

export interface ICampaignExperimentalReducerState {
  campaigns: CampaignExperimentalListResponseDto | null;
}

export const campaignExperimental = (state: ICampaignExperimentalReducerState, action: AnyAction): ICampaignExperimentalReducerState => {
  if (action.type === GET_ALL_CAMPAIGNS_EXPERIMENTAL) {
    return { ...state, campaigns: action.payload };
  }
  
  return state || { campaigns: null };
};
